import {WelcomeListItemModel} from "../../search/models/welcome-list-item";
import {WelcomeListCollection} from "../../search/collections/welcome-list";
import {autoinject} from "aurelia-dependency-injection";
import {backboneModelProperties} from "../../decorators/backbone-properties";
import {AppSettings} from "../../app-settings";
import {AppEvents} from "../../app-events";
import {BaseDocumentModel} from "../../desktop/models/base-document";
import {prop} from "../../decorators/property";
import {IRequestOptions} from "../interfaces/request-options";
import { AuthService } from "../../authentication/auth-service";
import { AppUser } from "../../authentication/app-user";

@autoinject
@backboneModelProperties({
    relations: [
        {
            type: Backbone.Many,
            key: "RecentSearches",
            relatedModel: WelcomeListItemModel,
            collectionType: WelcomeListCollection
        },
        {
            type: Backbone.Many,
            key: "RecentDocuments",
            relatedModel: WelcomeListItemModel,
            collectionType: WelcomeListCollection
        }
    ],
    defaults: {
        RecentSearches: [],
        RecentDocuments: []
    }
})
export class WelcomeModel extends Backbone.AssociatedModel {

    @prop() public RecentSearches: WelcomeListCollection;
    @prop() public RecentDocuments: WelcomeListCollection;
    private user: AppUser;

    constructor(private authService: AuthService, private appEvents: Backbone.Events) {
        super();
        this.user = this.authService.AppUser;
        this.setupEvents();
    }

    private setupEvents() {
        this.user.on("refresh", () => { this.hydrateActivityCollections(); });
        this.appEvents.on(AppEvents.DocumentLoaded, (model) => {
            this.saveDocument(model);
        });
        this.appEvents.on(AppEvents.SearchRequest, (options) => {
            this.saveSearch(options);
        });
    }

    private saveDocument(documentModel: BaseDocumentModel) {
        const collection = this.RecentDocuments;
        const docKey = documentModel.Id;
        if (this.user.Email) {
            let model = collection.where({ DocKey: docKey })[0];
            if (!model) {
                model = new WelcomeListItemModel({
                    Title: documentModel.Title,
                    Url: documentModel.Url,
                    DocKey: docKey
                });
            } else {
                collection.remove(model);
            }
            collection.unshift(model);
            collection.reset(collection.first(5));
            this.saveData();
        }
    }

    private saveSearch(request: IRequestOptions) {
        const collection = this.RecentSearches;
        if (this.user.Email) {
            let model = collection.where({ Query: request.query })[0];
            if (!model) {
                model = new WelcomeListItemModel({
                    Query: request.query,
                    Options: request
                });
            } else {
                collection.remove(model);
            }

            collection.unshift(model);
            collection.reset(collection.first(5));
            this.saveData();
        }
    }

    private saveData() {
        const key = `welcome_screen:${this.user.Email}`;
        window.localStorage.setItem(key, JSON.stringify(this.toJSON()));
    }

    private loadData() {
        const key = "welcome_screen:" + this.user.Email;
        this.set(JSON.parse(window.localStorage.getItem(key)));
    }

    private hydrateActivityCollections() {
        const user = this.user.Email;
        if (user) {
            this.loadData();
        } else {
            this.set(this.defaults);
        }
    }

    private getCategories(updatedDisplayCategories: Backbone.Collection<any>) {
        return updatedDisplayCategories.map((c) => {
            return c.Name;
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/welcome.ts